import React from 'react'
import ContactItem from '../components/ContactItem'
import Title from '../components/Title'
import phone from '../images/phone.svg';
import email from '../images/emailme.svg';


const Contact = () => {
    return (
        <div>
            <div className="title">
                <Title title={'Contact'} span={'Contact'} />
            </div>

            <div className="ContactPage">
                <div className="contact-sect">
                    <ContactItem icon={phone} text1={'+91-8920974024'} text2={'+91-8349100429'} title={'Phone'}/>
                    <ContactItem icon={email} text1={'anuragtomar2510@gmail.com'} text2={'anuragtomar492@gmail.com'} title={'Email'}/>
                </div>
            </div>
        </div>
    )
}

export default Contact
